import * as _ from 'lodash';

import LanguageCodeMapper from 'utils/language-code-mapper';


export class LanguagePageMixin {

  showMore: boolean = false;
  showMoreData: any = [];
  selectedLanguage: string = 'EN';
  languagesItems: any[] = [];

  getLanguagePath(item: any): string {
    return `${item.item_name}.${this.selectedLanguage}`;
  }

  getItemLanguages(item: any, data: any): string[] {
    return _.keys(_.get(data, item.item_name, []));
  }

  addLanguages(data: Array<string>) {
    this.languagesItems = _.map(data, (language: string) => {
      return {
        title: LanguageCodeMapper.getName(language),
        active: language === 'EN',
        code: language
      };
    });
  }
}
